import { render, staticRenderFns } from "./InformationSharingList.vue?vue&type=template&id=1447c661&"
import script from "./InformationSharingList.vue?vue&type=script&lang=js&"
export * from "./InformationSharingList.vue?vue&type=script&lang=js&"
import style0 from "./InformationSharingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports